import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Stats from './components/Stats';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Security from './pages/Security';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CloudArchitecture from './pages/CloudArchitecture';
import ApplicationDevelopment from './pages/ApplicationDevelopment';
import DevOpsAutomation from './pages/DevOpsAutomation';
import SecurityCompliance from './pages/SecurityCompliance';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App font-inter bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <Solutions />
              <Stats />
              <About />
              <Contact />
            </>
          } />
          <Route path="/security" element={<Security />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cloud-architecture" element={<CloudArchitecture />} />
          <Route path="/application-development" element={<ApplicationDevelopment />} />
          <Route path="/devops-automation" element={<DevOpsAutomation />} />
          <Route path="/security-compliance" element={<SecurityCompliance />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
